export enum PhoneNumberType {
    CallingPlan = "CallingPlan",
    DirectRouting = "DirectRouting",
    OperatorConnect = "OperatorConnect"
}
